import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLineThickness: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"line-thickness, lines, border"} maskId="square-filled-radius-0-stroke-1-IconLineThickness"><path d="M20 5V6H4V5H20Z" fill="currentColor"/><path d="M20 16V19H4V16H20Z" fill="currentColor"/><path d="M20 12V10H4V12H20Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconLineThickness;
